import React from 'react';
import { useSelector } from 'react-redux';
import { useIntl, FormattedMessage } from '../../util/reactIntl';
import {
  Page,
  UserNav,
  LayoutSideNavigation,
} from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import NotificationPreferencesForm from './NotificationPreferencesForm';
import css from './NotificationPreferences.module.css';

/**
 * Default notification options — clients can override via REACT_APP_NOTIFICATION_OPTIONS
 * (JSON array of { key, label }) or by editing this list.
 */
const DEFAULT_OPTIONS = [
  { key: 'newMessages', label: 'New messages from buyers/sellers' },
  { key: 'newBookings', label: 'New booking requests' },
  { key: 'bookingConfirmed', label: 'Booking confirmed' },
  { key: 'weeklyDigest', label: 'Weekly digest email' },
  { key: 'marketingEmails', label: 'Promotions & updates from us' },
];

const getOptions = () => {
  try {
    if (process.env.REACT_APP_NOTIFICATION_OPTIONS) {
      return JSON.parse(process.env.REACT_APP_NOTIFICATION_OPTIONS);
    }
  } catch (_) {}
  return DEFAULT_OPTIONS;
};

const NotificationPreferencesPage = () => {
  const intl = useIntl();
  const currentUser = useSelector(state => state.user?.currentUser);
  const scrollingDisabled = useSelector(state => state.UI?.scrollingDisabled ?? false);

  const title = intl.formatMessage({ id: 'NotificationPreferencesPage.title' });

  return (
    <Page title={title} scrollingDisabled={scrollingDisabled}>
      <LayoutSideNavigation
        topbar={
          <>
            <TopbarContainer
              currentPage="NotificationPreferencesPage"
              desktopClassName={css.desktopTopbar}
              mobileClassName={css.mobileTopbar}
            />
            <UserNav currentPage="NotificationPreferencesPage" />
          </>
        }
        sideNav={null}
        useAccountSettingsNav
        currentPage="NotificationPreferencesPage"
        footer={<FooterContainer />}
      >
        <div className={css.content}>
          <h1 className={css.heading}>
            <FormattedMessage id="NotificationPreferencesPage.heading" />
          </h1>
          <p className={css.description}>
            <FormattedMessage id="NotificationPreferencesPage.description" />
          </p>
          {currentUser ? (
            <NotificationPreferencesForm
              currentUser={currentUser}
              options={getOptions()}
            />
          ) : null}
        </div>
      </LayoutSideNavigation>
    </Page>
  );
};

export default NotificationPreferencesPage;
